import { ZaiChatSideChat } from '@winnin/zai-chat'

import type { IZaiNativeSideChatView } from './zai-native-side-chat.types'

export const ZaiNativeSideChatView = ({ isOpen, onOpenChange }: IZaiNativeSideChatView) => (
  <div className="zai-native-side-chat" data-open={isOpen}>
    <ZaiChatSideChat isOpen={isOpen} onOpenChange={onOpenChange} />
  </div>
)
